import React, { useEffect } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { KTSVG } from '../../../../../_metronic/helpers'
import { DocumentListWidget } from '../../../../modules/futurisk/DocumentListWidget'
import { HelpDocument } from '../../../../modules/auth'

type Props = {
  show: boolean
  handleClose: () => void
  Documents:HelpDocument[];
}

export const DocumentModal: React.FC<Props> = ({ show, handleClose,Documents }) => {
  useEffect(() => {
    initMap()
  }, [])

  //const [location, setLocation] = useState(data.location)
  const dissmissLocation = () => {
    //setLocation(data.location)
    handleClose()
  }

  const initMap = () => { }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_test'
      data-backdrop='static'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName=''
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Documents</h5>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={dissmissLocation}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-3x' />
          </div>
        </div>
        <div className='modal-body'>
          <Row>
            <Col xs={12} md={12}>
              <DocumentListWidget className={''} Documents={Documents} />
            </Col>
          </Row>
        </div>
        
      </div>
    </Modal>
  )
}

